// English strings (source language): charts and small components.

const en = {
  score: (n: number) => `${n} pts`,
  scoreTitle: 'Gruvetto score: your racing level, from 0 to 1000 points (about 200 points per W/kg)',
  elevationRange: (m: number, km: string) => `${m} m elevation range · ${km} km`,
};
export default en;
